import React from 'react'
import { UsersList } from 'organisms/UsersList'

import InviteUserContainer from 'organisms/InviteUser/container'
import { AdminContainer } from '../../../pages/Admin'
import ContainerShell from 'shared/components/ContainerShell'
import ContainerShellIntro from 'shared/components/ContainerShellIntro'
import useAxios from 'hooks/useAxios'
import { getRolesAndSurveyAccessVisibility } from 'domains/user'

/**
 * @typedef {Object} Props
 * @property {Array} accounts
 * @property {any} roles
 * @property {any} userMe
 */
export default function Users({ accounts, usedSeatCount, roles, userMe }) {
  const { data: teamMembersData, isLoading: isTeamMembersLoading } = useAxios({
    url: 'team-members/team-member-list/?limit=1000',
    method: 'POST',
    data: { global_operator: 'and', groups: [] },
  })
  const teamMembers = teamMembersData?.results ?? []
  const [roleOptions, surveyAccessSelectableRoles, dashbardAccessesSelectableRoles] =
    getRolesAndSurveyAccessVisibility(roles)

  const filteredAccounts = accounts

  return (
    <React.Fragment>
      <InviteUserContainer
        totalAccount={usedSeatCount ?? filteredAccounts.length}
        roleOptions={roleOptions}
        surveyAccessSelectableRoles={surveyAccessSelectableRoles}
        dashbardAccessesSelectableRoles={dashbardAccessesSelectableRoles}
      />
      <AdminContainer>
        <ContainerShell
          intro={
            <ContainerShellIntro
              helpLinkLabel="Learn more about managing users"
              helpLinkUrl="https://help.simplesat.io/en/articles/2361167-users-permissions"
              title="Users"
            />
          }
        >
          <UsersList
            accounts={filteredAccounts}
            userMe={userMe}
            roleOptions={roleOptions}
            surveyAccessSelectableRoles={surveyAccessSelectableRoles}
            dashbardAccessesSelectableRoles={dashbardAccessesSelectableRoles}
            teamMembers={teamMembers}
            isTeamMembersLoading={isTeamMembersLoading}
          />
        </ContainerShell>
      </AdminContainer>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Users/index.js